<!-- DIALOG -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<div class="card">
    <!-- OPTIONS -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
                class="p-button-success p-mr-2" (click)="eventCancel()"></button>
            <button pButton pRipple label="{{translations.lbl_release}} {{translations.lbl_volunteer}}"
                *ngIf="this.showRelease" icon="pi pi-chevron-left" class="p-button-success p-mr-2"
                (click)="releaseToSupport()"></button>
            <button pButton pRipple label="{{translations.lbl_assign}} {{translations.lbl_user}}"
                *ngIf="this.showAssign" icon="pi pi-chevron-left" class="p-button-success p-mr-2"
                (click)="assignToMyUser()"></button>
            <button pButton pRipple
                label="{{translations.lbl_assign}} {{translations.lbl_expert}} / {{translations.lbl_comments}}"
                *ngIf="this.showNew" icon="pi pi-plus" class="p-button-success p-mr-2" (click)="openNew()"></button>

            <button pButton pRipple label="{{translations.lbl_mark}} {{translations.lbl_solved}}"
                *ngIf="this.showSolved" icon="pi pi-plus" class="p-button-success p-mr-2" (click)="solved()"></button>
            <button pButton pRipple label="{{translations.delete_record}}" *ngIf="this.showDelete" icon="pi pi-trash"
                class="p-button-success p-mr-2" (click)="delete()"></button>
            <button pButton pRipple label="{{translations.lbl_close}}" *ngIf="this.showClosed" icon="pi pi-plus"
                class="p-button-success p-mr-2" (click)="close()"></button>
            <button pButton pRipple label="Rechazar {{translations.lbl_solution}}" *ngIf="this.showClosed"
                icon="pi pi-plus" class="p-button-success p-mr-2" (click)="reject()"></button>
            <button pButton pRipple label="{{translations.lbl_re_open}}"
                *ngIf="incidentDoc && incidentDoc.status == 'C'" icon="pi pi-plus" class="p-button-success p-mr-2"
                (click)="reOpen()"></button>
        </ng-template>
    </p-toolbar>

    <div class="p-grid">
        <!-- INFO DETAIL -->
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_id}}</span>
                    <span class="p-text-bold">{{incidentDoc?.incidentId || ''}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_name}}</span>
                    <span class="p-text-bold">{{incidentDoc?.personName || ''}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_email}}</span>
                    <span class="p-text-bold">{{incidentDoc?.email || ''}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_zone}}</span>
                    <span class="p-text-bold">{{incidentDoc?.zoneDesc || ''}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_national}}</span>
                    <span class="p-text-bold">{{incidentDoc?.natioDesc || ''}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_function}} {{translations.lbl_or}} {{translations.lbl_application}}</span>
                    <span class="p-text-bold">{{funcAppDesc}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_type}}</span>
                    <span class="p-text-bold">{{reportType}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_severity}}</span>
                    <span class="p-text-bold">{{severity}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_priority}}</span>
                    <span class="p-text-bold">{{priority}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{translations.lbl_subject}}</span>
                    <span class="p-text-bold">{{incidentDoc?.subject || ''}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_detail}}</span>
                    <span class="p-text-bold">{{incidentDoc?.body || ''}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_download}} {{translations.lbl_file}}</span>
                    <button type="button" *ngIf="!fileNameEmpty" pButton pRipple icon="pi pi-download"
                        (click)="onClickDownloadFile(incidentDoc)" pTooltip="{{incidentDoc?.fileName}}"></button>
                </div>
            </p-panel>
        </div>

        <!-- COMMENTS -->
        <div class="p-col-12 p-md-6">
            <span class="p-text-bold">{{translations.lbl_comments}} {{translations.lbl_manager}}</span>
            <p-panel>
                <p-editor #editor [(ngModel)]="mngComments" [style]="{'height':'200px'}"
                    (onTextChange)="updateIncident()" [readonly]="readOnlyEdit">
                    <p-header>
                        <span class="ql-formats">
                            <button type="button" class="ql-bold" aria-label="Bold"></button>
                            <button type="button" class="ql-italic" aria-label="Italic"></button>
                            <button type="button" class="ql-underline" aria-label="Underline"></button>
                        </span>
                    </p-header>
                </p-editor>
            </p-panel>
        </div>
    </div>

    <!-- TABLA -->
    <p-table #dt [value]="lstIncidentsDtl" [globalFilterFields]="['currDate', 'assignedTo']" [rowHover]="true"
        dataKey="id" styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true" responsive="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{translations.lbl_comments}} {{translations.lbl_incidents}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>
            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="sequence">{{translations.lbl_sequence}}<p-sortIcon field="sequence"></p-sortIcon>
                </th>
                <th pSortableColumn="currDate">{{translations.lbl_date}}<p-sortIcon field="currDate"></p-sortIcon></th>
                <th pSortableColumn="assignedTo">{{translations.lbl_assigned_to}}<p-sortIcon
                        field="assignedTo"></p-sortIcon></th>
                <th pSortableColumn="assignedTo">{{translations.lbl_starting_date}}<p-sortIcon
                        field="assignedTo"></p-sortIcon></th>
                <th pSortableColumn="comments">{{translations.lbl_comments}} {{translations.lbl_solution}}<p-sortIcon
                        field="comments"></p-sortIcon></th>
                <th pSortableColumn="spendTime">{{translations.lbl_hour}}<p-sortIcon field="spendTime"></p-sortIcon>
                </th>
                <th>{{translations.lbl_download}} {{translations.lbl_file}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value>
            <tr>
                <td>{{value.key.sequence}}</td>
                <td>{{value.currDate}}</td>
                <td>{{value.assignedTo}}</td>
                <td>{{value.movDate}}</td>
                <td class="p-d-flex p-ai-center p-jc-start">
                    <button pButton pRipple type="button" icon="pi pi-envelope"
                        class="p-button-rounded p-button-success p-button-text p-button-sm"
                        (click)="sendEmailComment(value)"></button>
                    <span class="p-ml-2">{{value.comments}}</span>
                </td>

                <td>{{value.spendTime}}</td>
                <td>
                    <button type="button" *ngIf="!fileNameIsEmpty(value.fileName)" pButton pRipple icon="pi pi-download"
                        (click)="onClickDownloadFileDtl(value)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>


<!-- DIALOG -->
<p-dialog [(visible)]="zoneDialog" [style]="{width: '750px'}" header="{{translations.lbl_incidents}}" [modal]="true"
    styleClass="p-fluid">
    <ng-template pTemplate="content">

        <div class="p-field">
            <label for="assigned">Asigando a / {{translations.lbl_solved}} {{translations.lbl_by}} * </label>
            <p-dropdown [options]="lstUsersSupportDoc" [(ngModel)]="selectedUsersSupport" placeholder="Asignado a"
                optionLabel="userName" [showClear]="true" [disabled]="rejectec"></p-dropdown>
            <small class="p-error" *ngIf="!selectedUsersSupport">{{translations.lbl_select}} asignado a.</small>
        </div>

        <div class="p-field">
            <label for="dateformat" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{translations.lbl_date}} *</label>
            <div class="p-col-12 p-md-10">
                <p-calendar [(ngModel)]="strDate" dateFormat="dd-MM-yy" inputId="dateformat" [showIcon]="true"
                    inputId="icon"></p-calendar>
                <small class="p-error" *ngIf="submitted && !strDate">{{translations.lbl_is_requiered}}</small>
            </div>
        </div>
        <div class="p-field">
            <label for="name">{{commentsTitle}} *</label>
            <input type="text" pInputText id="name" [(ngModel)]="comments" required autofocus />
            <small class="p-error" *ngIf="!comments">{{translations.lbl_comments}}
                {{translations.lbl_is_requiered}}.</small>
            <label for="spendTime">Horas de trabajo:</label>
            <p-inputNumber id="spendTime" [(ngModel)]="spendTime" mode="decimal" [max]="110"></p-inputNumber>


            <div class="image-upload">
                <img [src]="imageSrc" style="max-width:300px;max-height:300px" />
                <input name="imageUrl" type="file" accept="*/*" (change)="uploadEvidence($event)" />
            </div>

        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-times"
            class="p-button-danger p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="{{translations.lbl_save}}" icon="pi pi-check"
            class="p-button-success p-button-text" (click)="createUpdateIncidentDtl()"></button>
    </ng-template>
</p-dialog>